import LimitDialog from '~/components/Responsible/dialog/limit';

export const route: RouteDefinition = {
  preload: () => {},
  info: {
    login: true,
    dialog: {
      get title() {
        return t('Set Gambling Limit');
      },
      class: 'w-[500px]',
    },
  },
};

export default LimitDialog;
